
import {
    FETCH_SALES_PERSONAS_REQUEST,
FETCH_SALES_PERSONAS_SUCCESS,
FETCH_SALES_PERSONAS_FAILURE
} from '../../../../Constants/actionTypes';

const initialState = {
    loading: false,
    salesData: [],
    error: null,
};

const salesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SALES_PERSONAS_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_SALES_PERSONAS_SUCCESS:
            return { ...state, loading: false, salesData: action.payload };
        case FETCH_SALES_PERSONAS_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default salesReducer;
